import {} from './config';
import { DefaultMetadataController, DefaultStatsController } from '../controller';
import { DefaultAssetGenerationController } from '../controller/DefaultAssetGenerationController';
import { DefaultBookingController } from '../controller/DefaultBookingController';
export let makeConfig = () => {
    let config = {
        gamesController: new DefaultMetadataController("https://adp.api.advertise-in.games"),
        assetGenerationController: new DefaultAssetGenerationController("https://adg.api.advertise-in.games"),
        bookingController: new DefaultBookingController("https://adp.api.advertise-in.games"),
        keycloakConfig: {
            url: "https://iam.advertise-in.games",
            realm: "ad-venture-users",
            clientId: "frontend-client"
        },
        statsController: new DefaultStatsController("https://adp.api.advertise-in.games")
    };
    return config;
};
